
var KONGWANG = {
    /**
     * 空亡的数组数据
     * 戌亥、申酉、午未、辰巳、寅卯、子丑
     */
    kongWangArray: [[10, 11], [8, 9], [6, 7], [4, 5], [2, 3], [0, 1]],
    /**
     * 根据地支获取年空
     * @param {年柱/日柱} nianRiZhu 
     * @param {地支} zhi 
     */
    getNianKongByNianRiZhu(nianRiZhu, zhi) {
        // console.error('getNianKongByNianRiZhu-----', nianZhu, zhi)
        // 轮询六十甲子
        var tempZhi = 0, lun = 0, dui = 0;
        while(lun <= 6) {
            for(var i = 0; i < 10; i++) {
                var key = i+''+tempZhi, 
                    value = KONGWANG.kongWangArray[lun];
                if(nianRiZhu == key) {
                    // console.log('lun-----', key, value, value.indexOf(zhi) != -1);
                    return value.indexOf(zhi) != -1;
                }
                tempZhi = tempZhi < 11 ? tempZhi+1 : 0;
                lun = i == 9 ? lun+1 : lun;
                dui = i%2 != 0 ? dui+1 : dui;
                dui = dui <= 4 ? dui : 0;
            }
            if(lun == 6) {
                break;
            }
        }
        return false;
    },
}

export {
    KONGWANG
}